import { createContext, useContext, type ReactNode } from "react";

/**
 * When false: hide wallet, favorites, cart, notifications, hamburger, bottom-nav hub,
 * and buyer CTAs on ads — same as logged-out chrome, while the user may still be logged in
 * (e.g. profile / onboarding not completed).
 */
const AccountNavContext = createContext<boolean>(true);

export function AccountNavProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}) {
  return <AccountNavContext.Provider value={enabled}>{children}</AccountNavContext.Provider>;
}

export function useAccountNavEnabled(): boolean {
  return useContext(AccountNavContext);
}
